var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useStatus } from "../Utils/state";
import { UserBadge } from "./UserBadge";
export var Provider = function (_a) {
    var className = _a.className, setHamburgerOpen = _a.setHamburgerOpen, hamburgerOpen = _a.hamburgerOpen;
    var authState = useStatus();
    return (React.createElement(UserBadge, __assign({}, { authState: authState, className: className }, { setHamburgerOpen: setHamburgerOpen, hamburgerOpen: hamburgerOpen })));
};
